<div id="main-search"
    class="main-search open">
    <div class="input-group">
        <input id="m-search"
            type="text"
            class="form-control search-control"
            placeholder="Search . . ."/>
        <span class="input-group-append search-btn btn btn-primary">
            <i class="feather icon-search input-group-text"></i>
        </span>
    </div>
</div>
